import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "../-components/reservation-form";
import { Plus } from "lucide-react";
import { T } from "@/i18n";

export const Route = createFileRoute("/(reservations)/reservations/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  return (
    <Form
      clients={[]}
      accommodations={[]}
      reservationdays={[]}
      services={[]}
      isLoading={false}
      onSuccess={(id) => {
        navigate({ to: "/reservations/$id", params: { id } });
      }}
      crumbs={[
        {
          content: (
            <>
              <T tKey="reservations.new.title" />{" "}
              <Plus width={16} height={16} />
            </>
          ),
          href: "/reservations/new",
        },
      ]}
    />
  );
}
